import { MimeType, MIME_TYPES } from '@boltenergy-be/shared'

/**
 * Type-guard for mime type of File
 * @param {File["type"]} type
 * @returns {type is }
 */
export const isValidMimeType = (type: File['type']): type is MimeType => {
  return (Object.values(MIME_TYPES) as string[]).includes(type)
}
